/* global bootstrap */
import { ajaxContent } from './ajaxContent';

export const modalUtils = {
	init: () => {
		window.addEventListener( 'shown.bs.modal', ( event ) => {
			const ajaxContentWrapper = event.target.querySelector( '.ajax-content' );
			if ( ajaxContentWrapper ) {
				ajaxContent.loadAjaxContent( ajaxContentWrapper );
			}
		} );
	},
	closeModal: ( modalElement ) => {
		const modal = bootstrap.Modal.getInstance( modalElement );
		modal.hide();
	},
	openModal: ( modalElement ) => {
		const modal = bootstrap.Modal.getOrCreateInstance( modalElement );
		modal.show();
	},
	openAutoModal: () => {
		const modalId = getModalIdFromUrl();
		if ( modalId !== '' ) {
			modalUtils.openModal( document.getElementById( modalId ) );
			removeHash();
		}
	},
};

function removeHash() {
	history.pushState( '', document.title, window.location.pathname + window.location.search );
}

function getModalIdFromUrl() {
	let id = '';
	const hash = window.location.hash;
	const modalPrefix = '#modal-';
	if ( hash !== undefined && hash.startsWith( modalPrefix ) ) {
		id = hash.substring( modalPrefix.length ) + 'Modal';
	}
	return id;
}

